import { FC } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { HOMEPAGE_PATH } from 'utils/consts/path'
import CollapseButton, { CollapseButtonWrapper } from './CollapseButton'

const Wrapper = styled.div`
  display: flex;
  padding: 12px 24px 0;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  ${CollapseButtonWrapper} {
    opacity: 0;
    transition: opacity var(--animation-speed) cubic-bezier(0.2, 0, 0, 1);
  }

  :hover {
    ${CollapseButtonWrapper} {
      opacity: 1;
    }
  }
`

interface HeaderProps {
  collapsed: boolean
  setCollapsed: (value: boolean | ((prev: boolean) => boolean)) => void
}

const Header: FC<HeaderProps> = ({ collapsed, setCollapsed }) => {
  return (
    <Wrapper>
      <Link to={HOMEPAGE_PATH}>
        {collapsed ? (
          // prettier-ignore
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
            <path fill='#E7E7EA' fillRule='evenodd'
                  d='M2.48 24V0h19.04v18.7l-5.3 5.3H2.48ZM16.6 6.85h-2.53c-.23.46-.69.77-1.23.77H7.4v-2.7h5.44c.54 0 1 .39 1.23.85h2.53v1.08Zm-.53 14.92v-3.3h3.3l-3.3 3.3Zm-1.08-4.3h4.84V1.61H4.1v20.76H15v-4.92Zm-.92-1.93h2.53v-1.08h-2.53c-.23-.46-.69-.84-1.23-.84H7.4v2.69h5.44c.54.07 1-.31 1.23-.77Zm2.53-4.39h-2.53c-.23.54-.69.85-1.23.85H7.4V9.23h5.44c.54 0 1 .39 1.23.85h2.53v1.07Z'
                  clipRule='evenodd' />
          </svg>
        ) : (
          // prettier-ignore
          <svg xmlns='http://www.w3.org/2000/svg' width='136' height='24' fill='none' viewBox='0 0 136 24'>
            <path fill='#E7E7EA' fillRule='evenodd'
                  d='M2.48 24V0h19.032v18.692L16.218 24H2.48ZM16.6 6.846h-2.532c-.23.462-.69.77-1.228.77H7.392V4.922h5.448c.537 0 .998.385 1.228.846h2.533v1.077Zm-.537 14.923v-3.307h3.3l-3.3 3.307Zm-1.074-4.307h4.835V1.615H4.092v20.77h10.897v-4.923Zm-.92-1.924H16.6v-1.077h-2.533c-.23-.461-.69-.846-1.228-.846H7.392v2.693h5.448c.537.077.998-.308 1.228-.77Zm2.532-4.384h-2.533c-.23.539-.69.846-1.228.846H7.392V9.231h5.448c.537 0 .998.385 1.228.846h2.533v1.077Zm29.24-3.462A4.296 4.296 0 0 1 50.14 12a4.296 4.296 0 0 1-4.298 4.308h-.384A4.296 4.296 0 0 1 41.16 12a4.296 4.296 0 0 1 4.297-4.308h.384ZM55.358 15l-.46-.77a1.026 1.026 0 0 1-.231-.307c-.038-.039-.077-.058-.115-.077-.038-.02-.077-.039-.115-.077-.077-.077-.23-.077-.307-.077h-.69V16h-2.303V7.846h3.99a2.836 2.836 0 0 1 2.84 2.846c0 1-.46 1.846-1.305 2.385l.077.077c.154.077.23.23.307.384 0 .154.077.231.154.308a.385.385 0 0 0 .153.077c.058.02.115.038.154.077.153.077.23.077.383.077h.537V16l-.076.077c-.039 0-.058.019-.077.038-.02.02-.038.039-.077.039l-.152.039c-.236.062-.438.114-.692.114a2.75 2.75 0 0 1-.844-.153c-.23-.077-.46-.231-.69-.462-.231-.23-.385-.461-.461-.692Zm-20.184-2.846-1.458 3.923V16h-2.15l-2.455-8.154h2.456l1.304 4.692 1.842-4.692h.921l1.842 4.692 1.305-4.615h2.456l-2.456 8.154h-2.15l-1.457-3.923Zm18.264-.616V10h1.382a.77.77 0 0 1 0 1.538h-1.382Zm-7.75 2.616c-1.151 0-2.15-1-2.15-2.154s.999-2.154 2.15-2.154c1.15 0 2.148 1 2.148 2.154s-.997 2.154-2.148 2.154Zm19.8-6.23h3.53c2.302 0 4.144 1.845 4.144 4.076 0 2.23-1.842 4.077-4.144 4.077h-3.53V7.923Zm3.376 6h-.998V10h.998c1.074 0 1.995.846 1.995 2 0 1.077-.92 1.923-1.995 1.923Zm-9.516-6h2.303v6h2.916v2.153h-5.219V7.923Zm22.715-.078 1.843 4.692 1.304-4.692h2.456L85.21 16h-2.15l-1.458-3.923L80.145 16h-2.149L75.54 7.846h2.456l1.305 4.692 1.842-4.692h.92Zm8.826 8.23h-2.302V7.923h2.302v8.153Zm6.677-3.923L94.573 8l-.077-.077h-1.995v8.153h2.226v-4.384L97.797 16l.076.076h1.918V7.923h-2.225v4.23Zm9.055-4.23v2h-2.916V11h2.533v1.923h-2.533V14h2.916v2.076h-5.218V7.923h5.218Zm17.036 2.923.229.077c1.076.23 2.764.692 2.764 2.615 0 1.616-1.229 2.693-3.301 2.693-1.995 0-3.3-1-3.3-2.693v-.154h2.38v.154c0 .308.23.693.92.693.691 0 .921-.385.921-.693 0-.384-.613-.615-1.381-.769h-.077l-.009-.002c-1.15-.308-2.6-.695-2.6-2.536 0-1.231.768-2.539 3.07-2.539 2.225 0 3.07 1.308 3.07 2.539v.153h-2.303v-.153c0-.539-.613-.616-.767-.616-.154 0-.768.077-.768.616 0 .307.461.461 1.152.615Zm-4.605 5.231h-2.302V7.923h2.302v8.154Zm-8.518-8.154h2.302v6h2.916v2.154h-5.218V7.923Zm16.346 0v2.154h2.149v6.077h2.302v-6.077h2.148V7.923h-6.599Z'
                  clipRule='evenodd' />
          </svg>
        )}
      </Link>

      <CollapseButton
        collapsed={collapsed}
        onToggle={() => setCollapsed(prev => !prev)}
      />
    </Wrapper>
  )
}

export default Header
